import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ViewportService {
	public readonly isMobile = signal<boolean>(this.checkIsMobile());

	public constructor() {
		window.addEventListener('resize', () => {
			this.isMobile.set(this.checkIsMobile());
		});
	}

	private checkIsMobile(): boolean {
		return window.innerWidth <= 768;
	}
}
